import {SHOW_RANK_PROGRESSION_DETAIL} from '/redux/action/coach.action';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics/analytics.util';

export default () => (next: any) => (action: any) => {
  const {type: actionType, payload = {}} = action;

  return Promise.resolve(next(action)).then(() => {
    if (actionType === SHOW_RANK_PROGRESSION_DETAIL) {
      const {targetName} = payload;
      getAnalyticsUtilDefaultInstance().trackExpandPerformanceTarget({
        targetName,
      });
    }
  });
};
